var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video item-flex-center" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", {
      staticClass: "video-cover",
      style: {
        width: _vm.content.view_width / 2 + "px",
        height: _vm.content.view_height / 2 + "px",
        "background-image": "url(" + _vm.cover + ")",
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video-icon" }, [
      _c("i", { staticClass: "el-icon-video-play" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }